/**
 * SidebarNavDivider Component
 *
 * Visual separator for sidebar navigation sections.
 */

import cn from 'classnames';

import styles from './SidebarNavDivider.module.scss';

export interface SidebarNavDividerProps {
    /** Additional CSS class */
    className?: string;
}

export default function SidebarNavDivider(props: SidebarNavDividerProps) {
    const { className } = props;

    return <div role="separator" className={cn(styles.divider, className)} />;
}
